<template>
    <!-- Aba de Dados Pessoais -->
    
    <div class="tab-pane fade show active" id="designData">
        <h5 class="text mt-5 text-primary"><b>1. PROJECT INFORMATION</b></h5>
        <form ref="formCalculo" @submit.prevent>
            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="jobName" class="col-form-label">
                        <span><b>Job name</b></span>
                        <InterrogacaoHover text="Nome do projeto ou empreendimento. Identificação principal utilizada em todos os documentos e cálculos." />
                    </label>
                    <input type="text" class="form-control" id="jobName" v-model="designData.jobName" required />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 col-md-6 text-start">
                    <label for="jobNumber" class="col-form-label">
                        <span><b>Job number</b></span>
                        <InterrogacaoHover text="Número único do projeto utilizado para rastreabilidade, controle interno e integração com documentos técnicos." />
                    </label>
                    <input type="text" class="form-control" id="jobNumber" v-model="designData.jobNumber" required>
                </div>
                <div class="col-12 col-md-6 text-start">
                    <label for="tagNumber" class="col-form-label">
                        <span><b>Tag number</b></span>
                        <InterrogacaoHover text="Identificação única do equipamento (TAG). Utilizada em plantas industriais e documentos de engenharia." />
                    </label>
                    <input type="text" class="form-control" id="tagNumber" v-model="designData.tagNumber" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="equipmentDescription" class="col-form-label">
                        <span><b>Equipment description</b></span>
                        <InterrogacaoHover text="Descrição geral do equipamento, incluindo função, aplicação e características principais." />
                    </label>
                    <textarea
                    class="form-control"
                    id="equipmentDescription"
                    v-model="designData.equipmentDescription"
                    rows="4"
                    placeholder="Describe the equipment..."
                    ></textarea>
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="client" class="col-form-label">
                        <span><b>Client</b></span>
                        <InterrogacaoHover text="Nome do cliente ou empresa responsável pelo projeto ou contratação do equipamento." />
                    </label>
                    <input type="text" class="form-control" id="client" v-model="designData.client" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="documentNumber" class="col-form-label">
                        <span><b>Document number</b></span>
                        <InterrogacaoHover text="Número de identificação do documento técnico, usado para controle de revisões e rastreabilidade." />
                    </label>
                    <input type="text" class="form-control" id="documentNumber" v-model="designData.documentNumber" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="preparedBy" class="col-form-label">
                        <span><b>Prepared by</b></span>
                        <InterrogacaoHover text="Nome do responsável pela elaboração do documento ou cálculo." />
                    </label>
                    <input type="text" class="form-control" id="preparedBy" v-model="designData.preparedBy" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="checkedBy" class="col-form-label">
                        <span><b>Checked by</b></span>
                        <InterrogacaoHover text="Nome do responsável pela verificação técnica do documento ou cálculo." />
                    </label>
                    <input type="text" class="form-control" id="checkedBy" v-model="designData.checkedBy" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 text-start">
                    <label for="approvedBy" class="col-form-label">
                        <span><b>Approved by</b></span>
                        <InterrogacaoHover text="Nome do responsável pela aprovação final do documento técnico." />
                    </label>
                    <input type="text" class="form-control" id="approvedBy" v-model="designData.approvedBy" />
                </div>
            </div>

            <div class="form-group row justify-content-start">
                <div class="col-12 col-md-6 text-start">
                    <label for="reviewDate" class="col-form-label">
                        <span><b>Review date</b></span>
                        <InterrogacaoHover text="Data da revisão do documento. Utilizada para controle de versões e histórico do projeto." />
                    </label>
                    <input
                    type="date"
                    class="form-control"
                    id="reviewDate"
                    v-model="designData.reviewDate"
                    />
                </div>
            </div>

            <!-- Design Data -->
            <h5 class="text mt-5 text-primary"><b>2. VESSEL INFORMATION</b></h5>

            <div class="form-group row">
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>CODE DESIGN</b></h5>
                </div>
                <div class="col-6">
                    <h5 class="text mt-5 text-primary"><b>ASME VIII DIVISION 1 ED. 2023</b></h5>
                </div>
            </div>

            <div class="table-responsive mt-5">
                <table class="table table-hover align-middle table-fixed">
                    <thead>
                        <tr>
                            <th scope="col">DESIGN DATA</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Design Internal Pressure</b></span>
                                <InterrogacaoHover text="Pressão interna de projeto (Pint). Valor base utilizado no dimensionamento do vaso conforme ASME VIII Div.1." />
                            </th>
                            <td>Pint</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.designInternalPressure" required />
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Max Operation Pressure</b></span>
                                <InterrogacaoHover text="Pressão máxima de operação (Pmax). Valor limite para o funcionamento seguro do vaso." />
                            </th>
                            <td>Pomax</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.maxOperationPressure" required />
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Design External Pressure</b></span>
                                <InterrogacaoHover text="Pressão externa atuante no vaso, importante para análise de colapso por pressão externa." />
                            </th>
                            <td>Pext</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.designExternalPressure" required />
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Design Temperature</b></span>
                                <InterrogacaoHover text="Temperatura de projeto (DT). Define as propriedades mecânicas do material e limites operacionais." />
                            </th>
                            <td>DT</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.designTemperature" required />
                            </td>
                            <td>°C</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Room Temperature</b></span>
                                <InterrogacaoHover text="Temperatura ambiente de referência utilizada para comparação de propriedades do material." />
                            </th>
                            <td>RT</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.roomTemperature" required />
                            </td>
                            <td>°C</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Fluid</b></span>
                                <InterrogacaoHover text="Fluido contido no vaso. Influencia cálculos de densidade, pressão hidrostática e segurança." />
                            </th>
                            <td></td>
                            <td>
                                <input type="text" class="input form-control" v-model="designData.fluid" required/>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Density</b></span>
                                <InterrogacaoHover text="Densidade do fluido (kg/m³). Utilizada no cálculo da pressão hidrostática." />
                            </th>
                            <td>dens</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.density" required/>
                            </td>
                            <td>kg/m³</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Position</b></span>
                                <InterrogacaoHover text="Orientação do vaso (horizontal, vertical ou inclinado). Afeta distribuição de cargas e pressão hidrostática." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select" v-model="designData.position" required>
                                    <option disabled value="Selecione">Selecione</option>
                                    <option value="Horizontal">Horizontal</option>
                                    <option value="Vertical">Vertical</option>
                                    <option value="Inclined">Inclined</option>
                                </select>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Volume</b></span>
                                <InterrogacaoHover text="Volume do fluido contido no vaso." />
                            </th>
                            <td>V</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.volume" required/>
                            </td>
                            <td>m³</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Length Between Tangents (LBT)</b></span>
                                <InterrogacaoHover text="Distância entre as linhas de tangência do vaso, medida ao longo do eixo longitudinal. Representa o comprimento útil entre as regiões onde o casco ou os tampos mudam de geometria." />
                            </th>
                            <td><b>LBT</b></td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.lengthBetweenTangents" required/>
                            </td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Corrosion Allowance</b></span>
                                <InterrogacaoHover text="Margem adicional de espessura para compensar corrosão ao longo da vida útil do equipamento." />
                            </th>
                            <td>CA</td>
                            <td>
                                <input type="number" step="any" class="input form-control" v-model="designData.corrosionAllowance" required/>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Radiography</b></span>
                                <InterrogacaoHover text="Nível de inspeção radiográfica das soldas. Define a eficiência da junta (E) conforme ASME." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select" v-model="designData.radiography" required>
                                    <option disabled value="Selecione">Selecione</option>
                                    <option value="Total">Total</option>
                                    <option value="Partial">Partial</option>
                                    <option value="None">None</option>
                                </select>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Post Weld Heat Treatment</b></span>
                                <InterrogacaoHover text="Tratamento térmico após soldagem (PWHT). Reduz tensões residuais e melhora propriedades mecânicas." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select" v-model="designData.postWeldHeatTreatment" required>
                                    <option disabled value="Selecione">Selecione</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Fluid Class - Brazilian NR-13</b></span>
                                <InterrogacaoHover text="Classificação do fluido conforme a norma NR-13 brasileira." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select" v-model="designData.fluidClass" required>
                                    <option disabled value="Selecione">Selecione</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                </select>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>P.V</b></span>
                                <InterrogacaoHover text="Produto pressão × volume (P·V). Representa a pressão multiplicada pelo volume do vaso; usado para avaliar energia/armazenamento e em alguns cálculos de segurança e alívio. Unidade: MPa·m³." />
                            </th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ designData.pv }}
                                </h6>
                            </td>
                            <td>MPa.m³</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Potential Risk Group (NR-13)</b></span>
                                <InterrogacaoHover text="Classificação de risco potencial conforme a norma NR-13 brasileira." />
                            </th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ designData.potentialRiskGroup }}
                                </h6>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row" class="form-label">
                                <span><b>Category NR-13</b></span>
                                <InterrogacaoHover text="Classificação de categoria conforme a norma NR-13 brasileira." />
                            </th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ designData.categoryNR13 }}
                                </h6>
                            </td>
                            <td>--</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- <div class="form-group mt-3 row">
                <div class="col d-flex justify-content-start">
                    <img src="../img/asme-vii-division-1.png" width="600px" alt="Imagem de descrição">
                </div>
            </div> -->

        </form>
    </div>
</template>

<script>

import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";

export default {
    name: "DesignDataComponent",
    props: {
        designDataProps: {
            type: Object,
            required: true,
        },
    },
    components: {
        InterrogacaoHover,
    },
    data() {
        return {
            designData: this.designDataProps,
        };
    },
    mounted() {
        this.designData.position = "Selecione";
        this.designData.radiography = "Selecione";
        this.designData.postWeldHeatTreatment = "Selecione";
        this.designData.fluidClass = "Selecione";
    },
    watch: {
        'designData.maxOperationPressure': 'calculos',
        'designData.volume': 'calculos',
        'designData.fluidClass': 'calculos',
    },

    methods: {
        validarCamposObrigatorios() {
            const form = this.$refs.formCalculo;

            if (!form.checkValidity()) {
                form.reportValidity();
                return false;
            }

            return true;
        },

        calculos(){
            // Calcular P.V
            this.designData.pv = this.designData.maxOperationPressure * this.designData.volume;

            // Calcular Potencial Risk Group
            if(this.designData.pv > 100){
                this.designData.potentialRiskGroup = "1";
            } else if(this.designData.pv < 1){
                this.designData.potentialRiskGroup = "5";
            } else if(this.designData.pv < 100 && this.designData.pv > 30){
                this.designData.potentialRiskGroup = "2";
            } else if(this.designData.pv < 30 && this.designData.pv > 2.5){
                this.designData.potentialRiskGroup = "3";
            } else {
                this.designData.potentialRiskGroup = "4";
            }

            // Calcular Category NR-13
            const tabela = {
                A: { 1: 'I',  2: 'I',   3: 'II',  4: 'III', 5: 'III' },
                B: { 1: 'I',  2: 'II',  3: 'III', 4: 'IV',  5: 'IV'  },
                C: { 1: 'I',  2: 'II',  3: 'III', 4: 'IV',  5: 'V'   },
                D: { 1: 'II', 2: 'III', 3: 'IV',  4: 'V',   5: 'V'   },
            };

            const classe = this.designData.fluidClass;         // 'A', 'B', 'C' ou 'D'
            const grupo = this.designData.potentialRiskGroup;  // 1 a 5

            this.designData.categoryNR13 = tabela[classe]?.[grupo] ?? '-';
        }
    },
};
</script>

<style>

/* APENAS CELULAR */
@media (max-width: 575px) {
    .input {
        width: 150px;
    }

    .form-select{
        display: block !important;
    }
}
</style>